<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input placeholder="请输入商品名称" v-model="queryInfo.query" clearable @clear="getGoodsList">
            <!-- <el-button slot="append" icon="el-icon-search" @click="getGoodsList"></el-button> -->
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.school_sign" placeholder="学标奶">
                <el-option
                  v-for="item in xuebiao"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.status" placeholder="上架状态">
                <el-option
                  v-for="item in shangjia"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.jxtype" placeholder="经销渠道">
                <el-option
                  v-for="item in jxtypelist"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="getGoodsList">搜索</el-button>
          <!-- <div class="tip">添加低温商品前，请先设置截止时间</div> -->
        </el-col>
        <el-col :span="2">
          <a class="aaaa" :href="exportUrl + '&query=' + queryInfo.query + '&school_sign=' + queryInfo.school_sign + '&status=' + queryInfo.status + '&jxtype=' + queryInfo.jxtype">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
        <el-col :span="2" v-if="canLook == 1">
          <el-button type="primary" @click="goAddpage">添加商品</el-button>
          <div class="tip">添加低温商品前，请先设置截止时间</div>
        </el-col>
        <el-col :span="2" v-if="canLook == 1">
          <el-button type="info" @click="goToSetEndTime">设置低温商品截止时间</el-button>
        </el-col>
        <!-- <el-col :span="4" v-if="canLook == 1">
          <el-button type="info" @click="goToSetShui">设置商品税率</el-button>
        </el-col> -->
      </el-row>

      <!-- table表格区域 -->
      <el-table :data="goodslist" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品名称" prop="title"></el-table-column>
        <el-table-column label="商品类型" prop="type" width="80px"></el-table-column>
        <el-table-column label="学标奶" prop="school_sign" width="80px" align="center"></el-table-column>
        <el-table-column label="商品编号" prop="number" width="100px"></el-table-column>
        <el-table-column label="封面" width="120px" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.fengmian" fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="商品价格" align="center" prop="price" width="95px"></el-table-column>
        <el-table-column label="商品库存" prop="kucun" width="70px"></el-table-column>
        <el-table-column label="经销渠道" align="center" prop="jxtype" width="70px"></el-table-column>
        <el-table-column label="单位" align="center" prop="unit" width="70px"></el-table-column>
        <el-table-column label="重量系数" prop="weight" width="90px"></el-table-column>
        <el-table-column label="规格" prop="preNum" width="90px"></el-table-column>
        <el-table-column label="创建时间" prop="create_at" width="130px">
          <!-- <template slot-scope="scope">
            {{ scope.row.add_time | dateFormat }}
          </template> -->
        </el-table-column>
        <el-table-column label="上架状态" width="100px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="goodStateChanged(scope.row)"> </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="170px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="editById(scope.row.id)"></el-button>
            <el-button type="primary" size="mini" @click="editOrder(scope.row.id)">独立价格</el-button>
            <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)"></el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>

      <!-- 显示列表对话框 -->
      <el-dialog title="商品价格添加" :visible.sync="editGoodVisible" width="30%" @close="editGoodDialogClosed" center>
        <el-form :model="editGoodForm" :rules="editGoodFormRule" ref="editGoodFormRef" label-width="100px">
          <el-form-item label="商品名称" prop="title">
            <el-input v-model="editGoodForm.title" disabled></el-input>
          </el-form-item>
          <el-form-item label="用户级别" prop="level">
            <el-input v-model="editGoodForm.level"></el-input>
          </el-form-item>
          <el-form-item label="一级价格" prop="price1">
            <el-input v-model="editGoodForm.price1"></el-input>
          </el-form-item>
          <el-form-item label="二级价格" prop="price2">
            <el-input v-model="editGoodForm.price2"></el-input>
          </el-form-item>
          <el-form-item label="三级价格" prop="price3">
            <el-input v-model="editGoodForm.price3"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editGoodVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeGoodClick">确定添加</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="de" width="80%"  @close="editGoodDialogClosed" center >
        <Detail ref="detail"  :valueId="order_id"/>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Detail from "./DetailList.vue"
export default {
  components: {
    Detail
  },
  data () {
    return {
      de:false,
      order_id:'',
      editGoodVisible: false,
      editGoodForm: {
        title: null,
        level: null,
        price1: null,
        price2: null,
        price3: null
      },

      editGoodFormRule: {
        level: [
          { required: true, message: '请输入用户级别', trigger: 'blur' }
        ],
        price1: [
          { required: true, message: '请输入商品一级价格', trigger: 'blur' }
        ],
        price2: [
          { required: true, message: '请输入商品二级价格', trigger: 'blur' }
        ],
        price3: [
          { required: true, message: '请输入商品三级价格', trigger: 'blur' }
        ]
      },
      canLook: 1,
      // 查询参数对象
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10
      },
      xuebiao:[
          {id:'',label:'全部'},
          {id:1,label:'学标奶'},
          {id:2,label:'非学标奶'},
        ],
      shangjia:[
          {id:'',label:'全部'},
          {id:1,label:'上架'},
          {id:2,label:'未上架'},
        ],
      jxtypelist:[
          {id:'',label:'全部'},
          {id:1,label:'团购'},
          {id:2,label:'校园'},
          {id:3,label:'全渠道'},
          {id:4,label:'特渠'},
        ],
      // 商品列表
      goodslist: [],
      exportUrl: 'https://hsapi.hsxsn.cn//exportGoodsList?mPhone=' + localStorage.getItem('phone'),
      // exportUrl: 'http://huangshi-localhost/exportGoodsList?mPhone=' + localStorage.getItem('phone'), 
      // 总数据条数
      total: 0
    }
  },
  created () {
    this.getGoodsList()
  },
  methods: {
    // 关闭弹窗
    editGoodDialogClosed(){
      this.editGoodVisible = false
    },
    // 打开添加弹窗
    editById1 (row) {
      this.editGoodVisible = true
      console.log("商品LLO",row);
      this.editGoodForm.title = row.title;
    },
     // 确认添加
    changeGoodClick(){
     alert("确认添加")
    },
    // 根据分页获取对应的商品列表
    async getGoodsList () {
      const { data: res } = await this.$http.post('admin/good/list', {
        params: this.queryInfo
      })

      if (res.code !== 200) {
        return this.$message.error('获取商品列表失败！')
      }

      this.$message.success('获取商品列表成功！')
      console.log(res.result)
      this.goodslist = res.result.list
      this.total = res.result.count
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getGoodsList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getGoodsList()
    },
    async removeById (id) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该商品, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }
      const { data: res } = await this.$http.post('admin/good/delete', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除失败！')
      }
      this.$message.success('删除成功！')
      this.getGoodsList()
    },

    // 监听 switch 开关状态的改变
    async goodStateChanged (userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/good/updateStatus', {
        status: userinfo.status,
        id: userinfo.id
      })
      if (res.code !== 200) {
        userinfo.mg_state = !userinfo.mg_state
        return this.$message.error('更新商品状态失败！')
      }
      this.$message.success('更新商品状态成功！')
    },

    goAddpage () {
      this.$router.push('/goods/add')
    },

    // 低温商品截止时间设置
    goToSetEndTime () {
      this.$router.push('/goods/dwGoodEndTime')
    },

    // 低温商品税率
    goToSetShui () {
      this.$router.push('/goods/setGoodInvoice')
    },

    // 编辑
    editById (id) {
      console.log(id);
      this.$router.push({ path: '/goods/add', query: { id: id } })

    },
     // 编辑
     editOrder(id) {
      // alert(id)
      // console.log(id)
      this.order_id = id
      this.de = true
      //alert(this.order_id)
      //注意：此时show是editClientManage.vue定义的show()方法
      // state.edits.show(id);
      //this.$router.push({ path: '/orders/detail', query: { id: id ,show:this.canLook} })
    },
  }
}
</script>

<style lang="less" scoped>
.tip {
  font-size: 13px;
  color: #cccccc;
}
</style>
